export const GENRE_COLORS = { 소설:"#7b6cd4", 인문학:"#4ba8a0", 시:"#c9a84c" };

/**
 * 감정 좌표의 축을 정하는 기준.
 *   소설류  → 밝음/어두움 · 차분/격렬
 *   그 외   → 가벼움/무거움 · 실용적/사색적
 *
 * 예전에는 firestoreHelpers.js 와 EmotionCoordinate.js 에 같은 배열이
 * 따로 있었다. 한쪽만 고치면 태그와 축이 어긋나므로 여기로 모은다.
 *
 * 역사소설·로맨스·미스터리·스릴러·공포·아동문학·청소년소설이 빠져 있어
 * 소설인데 소설이 아닌 축을 받고 있었다. 반대로 '동화'·'추리' 는 여기
 * 있으면서 고를 수는 없는 죽은 값이었다 — 아동문학·미스터리와 같은 말이라
 * 하나로 모은다.
 * 이미 찍힌 좌표 160개 중 뜻이 바뀌는 것은 3개다.
 */
export const FICTION_GENRES = [
  "소설", "세계문학", "역사소설", "SF", "판타지", "로맨스", "미스터리",
  "스릴러", "공포", "시", "희곡", "아동문학", "청소년소설",
];

/**
 * 고를 수 있는 장르. BookHero 안에만 있어서 등록 화면에서는 쓸 수 없었다.
 *
 * '기타' 는 넣지 않는다. 장르는 라벨이 아니라 감정 좌표의 축을 정하는
 * 값인데, 검색 API 가 장르를 안 주면 '기타' 로 들어가 실제로 182권 중
 * 77권(42%)이 그렇게 쌓였다. 그 42%가 잘못된 축 위에 찍히고 있었다.
 * 등록할 때 반드시 고르게 한다.
 *
 * 이미 '기타' 로 들어간 책은 책 화면에서 고칠 수 있게 그대로 둔다 —
 * 일괄로 바꾸면 정말 소설이 아닌 책까지 소설 축으로 옮겨간다.
 */
export const GENRE_LIST = [
  "소설", "세계문학", "역사소설", "SF", "판타지", "로맨스", "미스터리", "스릴러", "공포",
  "시", "희곡", "에세이", "만화",
  "전기", "자서전", "역사", "철학", "심리학", "인문학",
  "자기계발", "경영", "경제",
  "과학", "기술", "IT", "수학", "의학",
  "예술", "음악", "디자인", "건축", "사진",
  "요리", "여행", "건강", "스포츠", "자연",
  "종교", "사회과학", "정치", "교육", "법학", "언어",
  "아동문학", "청소년소설", "아동",
  "문학비평", "유머", "범죄실화", "참고서", "학습",
];

/** 행성 색을 직접 고를 수 있게 되는 등록 권수 */
export const COLOR_UNLOCK = 10;
/** 행성 꼭대기에 여행자가 찾아오는 권수. 행성 색 다음 단계다.
 *  담아두기만 한 책은 세지 않는다 — 남의 행성에서는 user.bookIds(담아둔 책
 *  제외)로 셀 수밖에 없어서, 내 화면도 같은 기준이어야 둘이 어긋나지 않는다. */
export const TRAVELER_UNLOCK = 30;
/** 여우가 여행자 옆에 와서 앉는 권수. 여행자 다음 단계다. */
export const FOX_UNLOCK = 50;
/** 홈에서 "몇 권 남았다" 를 알려주기 시작하는 지점.
 *  0 = 처음부터. 아직 한 권도 없을 때 목표가 먼저 보이는 편이 낫다. */
export const COLOR_HINT_FROM = 0;
